import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';
import FormGroup from 'components/FormGroup/FormGroup';
import FormItem from 'components/FormItem/FormItem';

import useApi from 'utils/api';
import { useAuth } from 'utils/auth';
import classNames from 'utils/classNames';

import styles from '../../terminal.scss';

const TestPaymentStep = ({ terminalSettings }) => {
    const api = useApi();
    const auth = useAuth();

    const [isLoading, setIsLoading] = React.useState(false);
    const [widgetShown, setWidgetShown] = React.useState(false);

    const [yooKassaDone, setYooKassaDone] = React.useState(false);
    const [yooKassaFail, setYooKassaFail] = React.useState(false);

    const companyId = auth?.company.id;

    function getPaymentToken() {
        setIsLoading(true);
        setYooKassaFail(false);

        api.performTestPayment(companyId, terminalSettings.id)
            .then((response) => {
                if (response.payment_token) {
                    setWidgetShown(true);

                    const checkout = new window.YooMoneyCheckoutWidget({
                        confirmation_token: response.payment_token,
                        error_callback: (error) => {
                            console.error(error);
                        },
                    });

                    checkout.on('success', () => {
                        setWidgetShown(false);
                        setYooKassaDone(true);
                    });

                    checkout.on('fail', () => {
                        setWidgetShown(false);
                        setYooKassaFail(true);
                    });

                    checkout.render('yooKassaForm');
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <FormGroup>
            {!yooKassaDone && !yooKassaFail && (
                <FormItem>
                    <p className={styles.note}>
                        Пожалуйста, проведите <b>тестовый платёж</b>, чтобы проверить работоспособность терминала. Он
                        состави всего <b>10 рублей</b>. Деньги автоматически вернутся на вашу карту.
                    </p>
                    <br />
                    <p
                        className={classNames(styles.note, {
                            [styles.danger]: true,
                        })}
                    >
                        Используйте оплату банковской картой.
                    </p>
                </FormItem>
            )}

            {!widgetShown && !yooKassaDone && !yooKassaFail && (
                <FormItem>
                    <Button
                        loading={isLoading}
                        onClick={getPaymentToken}
                        text="Совершить тестовый платёж"
                        level="secondary"
                    />
                </FormItem>
            )}

            {widgetShown && (
                <FormItem>
                    <p className={styles.note}>Выберите оплату банковской картой.</p>
                </FormItem>
            )}

            {!yooKassaDone && <div id="yooKassaForm" />}

            {yooKassaDone && (
                <FormItem>
                    <p className={styles.note}>
                        Платёж проведён успешно. Пожалуйста, обновите страницу, и откройте настройки терминала ЮКассы
                        заново.
                    </p>
                </FormItem>
            )}

            {yooKassaFail && (
                <FormItem>
                    <p className={styles.note}>
                        Не удалось завершить платёж. Попробуйте повторить оплату сейчас или немного позже.
                    </p>
                </FormItem>
            )}

            {yooKassaFail && (
                <FormItem>
                    <Button
                        loading={isLoading}
                        onClick={getPaymentToken}
                        text="Повторить платёж"
                        level="secondary"
                    ></Button>
                </FormItem>
            )}
        </FormGroup>
    );
};

TestPaymentStep.propTypes = {
    terminalSettings: PropTypes.shape({
        id: PropTypes.number,
    }),
};

export default TestPaymentStep;
